import * as types from "@/store/types";

export default {
  [types.FECTH_PROFILE](state, { profile }) {
    state.profile = profile;
  },
  [types.FECTH_PROFILES](state, { profiles }) {
    state.profiles = profiles.data;
  },
  [types.LIST_SEARCH_USERS](state, { profiles }) {
    state.profiles = profiles.data;
    state.meta = profiles.meta;
  },
  [types.SEND_SMILE](state, { smile }) {
    state.smile = smile;
  },
  [types.LIST_BLOCKED](state, { blocked }) {
    state.blocked = blocked;
    state.meta = blocked.meta;
  },
  [types.SEND_COMPLAINTS](state, { complaints }) {
    state.complaints = complaints.data;
  },
  [types.SHOW_IMAGES](state, { photos }) {
    state.photos = photos;
  },
  [types.MORE_PROFILES](state, moreprofiles) {
    state.moreprofiles = moreprofiles;
  },

  [types.SHOW_SETTINGS](state, { settings }) {
    state.settings = settings;
  },

  [types.APPEND_SEEN_USER](state, { node }) {
    if (state.seenProfilesLength === 0) {
      state.seenProfilesLinkedList.value = node.value;
      state.seenProfilesLinkedList.index = 1;
      state.seenProfilesTail = state.seenProfilesLinkedList;
      state.seenProfilesLength  += 1;
      return;
    }

    node.prev = state.seenProfilesTail;
    state.seenProfilesTail.next = node;
    state.seenProfilesTail = node;
    state.seenProfilesLength += 1;
    node.index =  state.seenProfilesLength;
  },

  [types.SET_CURRENT_PAGE_PAGINATION](state, { page }) {
    state.currentPaginationPage = page;
  },

  [types.STORE_SEARCH_PARAMS](state, params) {
    state.searchParams = params;
  },

  [types.TRAVERSE_TO_ID](state, { userId }) {
    let nodeId = -1;
    let currentNode = state.seenProfilesLinkedList;
    while(currentNode){
      nodeId = currentNode.value.id
      if (nodeId === userId) {
        break;
      }
      currentNode = currentNode.next;
    }
    state.currentSeenUser = currentNode;
  }
};
